module.exports = "/_next/static/images/instrument_1-106c0c7277fe7a1ed222e3c90d79cf20.png";